module.exports = __webpack_public_path__ + "img/banner.f79820d1.png";